import { motion } from 'framer-motion';

/**
 * Premium animated tagline with flight path and minimalist airplane
 * Madrid → Europa & LATAM
 */
export const HeroTagline = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.2 }}
      className="inline-flex items-center gap-2 sm:gap-3 px-3 sm:px-5 py-2 sm:py-2.5 bg-white/[0.03] backdrop-blur-md border border-gold/25 rounded-full mb-10 relative overflow-hidden max-w-full"
      data-testid="hero-badge"
    >
      {/* Subtle background glow */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-gold/5 to-transparent" />
      
      {/* Live pulse dot */}
      <span className="relative w-1.5 h-1.5 rounded-full bg-gold pulse-dot flex-shrink-0" />
      
      {/* Tagline */}
      <span className="relative font-mono text-[8px] sm:text-[10px] tracking-[0.15em] sm:tracking-[0.22em] uppercase text-white/80 flex items-center gap-1.5 sm:gap-2 whitespace-nowrap">
        <span>Performance Marketing</span>
        <span className="text-white/30">|</span>
        <span className="text-white">Madrid</span>

        {/* Inline flight path SVG — oculto en móvil */}
        <span className="relative hidden sm:inline-flex items-center" style={{ width: '60px', height: '20px' }}>
          <svg
            viewBox="0 0 60 20"
            className="absolute inset-0 w-full h-full overflow-visible"
            preserveAspectRatio="none"
          >
            {/* Dashed curved route */}
            <defs>
              <linearGradient id="routeGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#B8923F" stopOpacity="0.3" />
                <stop offset="50%" stopColor="#DCC47D" stopOpacity="0.9" />
                <stop offset="100%" stopColor="#A93D52" stopOpacity="0.6" />
              </linearGradient>
              <linearGradient id="trailGrad" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="#DCC47D" stopOpacity="0" />
                <stop offset="100%" stopColor="#DCC47D" stopOpacity="1" />
              </linearGradient>
            </defs>
            
            {/* Static curved path (subtle) */}
            <path
              d="M 2 14 Q 30 -4 58 14"
              stroke="url(#routeGrad)"
              strokeWidth="0.8"
              fill="none"
              strokeDasharray="2 3"
              opacity="0.6"
            />
            
            {/* Animated traveling plane along path */}
            <g>
              <animateMotion
                dur="3.5s"
                repeatCount="indefinite"
                rotate="auto"
                keyTimes="0;1"
                keySplines="0.45 0 0.55 1"
                calcMode="spline"
              >
                <mpath href="#flightPath" />
              </animateMotion>
              
              {/* Glow under plane */}
              <circle r="3" fill="#DCC47D" opacity="0.4" />
              {/* Plane shape (minimalist triangle) */}
              <path
                d="M 2.5 0 L -1.5 -1.5 L -0.5 0 L -1.5 1.5 Z"
                fill="#FFFFFF"
              />
            </g>
            
            {/* Hidden reference path for animateMotion */}
            <path
              id="flightPath"
              d="M 2 14 Q 30 -4 58 14"
              fill="none"
              stroke="none"
            />
          </svg>
        </span>
        
        <span className="sm:hidden text-white/30">·</span>
        <span className="text-white">Europa</span>
        <span className="text-gold">&amp;</span>
        <span className="text-white">LATAM</span>
      </span>
    </motion.div>
  );
};
